var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    HelpButton: true,
    hidden:
      _vm.$store.state.ui.mode === 'no-map' ||
      _vm.$store.state.ui.mode === 'no-years' ||
      _vm.$store.state.ui.mode === 'year-highlight' ||
      _vm.$store.state.ui.mode === 'highlight-flip'
  },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" ? ")])}
var staticRenderFns = []

export { render, staticRenderFns }